import React, { useState } from 'react';
import { cond, propEq, propOr } from 'ramda';
import { withPrefix } from 'gatsby';
import { useIntl } from 'gatsby-plugin-intl';
import { findByName } from '../../utils';
import { renderWhenTrue } from '../../utils/rendering';
import { Container, TitleWrapper, Title, VideoComponent, ClickCover, CoverWrapper } from './video.styles';
import { useBreakpointsContext } from '../../store/BreakpointsContext';
import { Modal } from '../modal';

export const Video = ({ category, elements }) => {
  const [isOpen, setOpen] = useState(false);
  const title = propOr('', 'value', findByName('Title', elements));

  const { isDesktop } = useBreakpointsContext();

  const handleRequestClose = () => setOpen(false);
  const intl = useIntl();
  const renderTitle = (_, key) =>
    renderWhenTrue(() => (
      <TitleWrapper key={key}>
        <Title>{intl.formatMessage({ id: title })}</Title>
      </TitleWrapper>
    ))(!!title);

  const renderVideo = (video, key) => (
    <Modal
      key={key}
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      styles={{
        content: {
          height: 'auto',
          width: isDesktop ? '80%' : '100%',
          padding: isDesktop ? '25px' : '0',
        },
      }}
    >
      <VideoComponent dangerouslySetInnerHTML={{ __html: video.html }} />
    </Modal>
  );

  const renderClickCover = ({ url }, key) => (
    <CoverWrapper key={key}>
      <ClickCover src={withPrefix(url)} onClick={() => setOpen(true)} />
    </CoverWrapper>
  );

  const renderElement = cond([
    [propEq('name', 'Title'), renderTitle],
    [propEq('name', 'Youtube URL'), renderVideo],
    [propEq('name', 'Image Cover'), renderClickCover],
  ]);

  return <Container category={category}>{elements.map(renderElement)}</Container>;
};
